const currentUrl = window.location.origin;
export const scheme = `
<div class="w-full lg:w-[80%] mx-auto mt-32">
   <h2 class="lg:text-4xl font-medium text-[#000072] text-xl text-center"
   data-aos="fade-up"
    data-aos-delay="200"
   >
          We support Government schemes
    <br />
    Empowering access to credit across India.
        </h2>
  <br />
  <p
    class="py-2 text-center text-gray-900 mb-6 max-w-xl mx-auto"
    data-aos="fade-up"
    data-aos-delay="200"
  >
    Intelligent Al driven features that add tangible value to our customers
    Businesses & lenders a transformative user Experience for all Stakeholders
    involved.
  </p>

  <div class="grid grid-cols-1 lg:grid-cols-2 gap-4 w-full mx-auto">
    <!-- Card 1: CGTMSE -->
    <div
      class="w-full p-6 flex flex-col items-center text-center rounded-lg shadow-md border border-gray-300 bg-gray-50"
      data-aos="zoom-in"
      data-aos-duration="500"
    >
      <div class="w-36 aspect-[4/3] mb-4">
        <img
          src="https://cdn.jsdelivr.net/gh/heisenpreet/ibankeyAssest@master/cgtmse.png"
          class="w-full h-full object-contain"
          alt="CGTMSE - Credit Guarantee Fund Trust for Micro and Small Enterprises"
        />
      </div>
      <p class="text-3xl font-semibold text-gray-900 py-2">CGTMSE</p>
      <p class="text-xs text-gray-600">
        Credit Guarantee Fund Trust for Micro and <br />
        Small Enterprise.
      </p>
      <p class="text-3xl text-gray-900 font-bold mt-5">
        <i class="fa-solid fa-indian-rupee-sign"></i> 10 Cr.
      </p>
      <p class="text-xs text-gray-600 mt-2 px-6 mb-2">
        CGTMSE guarantees loans given to MSMEs by lending institutions like
        banks and NBFCs. This guarantee
      </p>
      <div class="flex gap-6 mt-auto">
        <a
          href="#"
          aria-label="Learn more about CGTMSE scheme"
          class="group inline-flex items-center text-gray-800 hover:text-blue-600 border border-transparent hover:border-blue-600 px-4 py-2 rounded-full transition-all duration-300"
        >
          Learn More
          <i
            class="fa-solid fa-arrow-right text-lg ml-2 transform group-hover:translate-x-1 transition-transform duration-300"
          ></i>
        </a>
        <a
        href="${currentUrl}/signup/#/signupBorrower"
        aria-label="Apply for CGTMSE scheme"
          class="px-6 py-2 text-white rounded-md bg-blue-700 hover:bg-blue-900 transition"
        >
          Apply now
        </a>
      </div>
    </div>

    <!-- Card 2: SATAT -->
    <div
      class="w-full p-6 flex flex-col items-center text-center rounded-lg shadow-md border border-gray-300 bg-gray-50"
      data-aos="zoom-in"
      data-aos-duration="500"
    >
      <div class="w-36 aspect-[4/3] mb-4">
        <img
          src="https://cdn.jsdelivr.net/gh/heisenpreet/ibankeyAssest@master/satat.png"
          class="w-full h-full object-contain"
          alt="SATAT - Sustainable Alternative Towards Affordable Transportation"
        />
      </div>
      <p class="text-3xl font-semibold text-gray-900 py-2">SATAT</p>
      <p class="text-xs text-gray-600">
        Sustainable Alternative Towards <br />
        Affordable Transportation.
      </p>
      <p class="text-3xl text-gray-900 font-bold mt-5">
        <i class="fa-solid fa-indian-rupee-sign"></i> 20 Cr.
      </p>
      <p class="text-xs text-gray-600 mt-2 px-6 mb-2">
        SATAT scheme on Compressed Bio Gas (CBG) encourages entrepreneurs to set
        up CBG plants, produce
      </p>
      <div class="flex gap-6 mt-auto">
        <a
          href="#"
          aria-label="Learn more about SATAT scheme"
          class="group inline-flex items-center text-gray-800 hover:text-blue-600 border border-transparent hover:border-blue-600 px-4 py-2 rounded-full transition-all duration-300"
        >
          Learn More
          <i
            class="fa-solid fa-arrow-right text-lg ml-2 transform group-hover:translate-x-1 transition-transform duration-300"
          ></i>
        </a>
        <a
        href="${currentUrl}/signup/#/signupBorrower"
        aria-label="Apply for SATAT scheme"
          class="px-6 py-2 text-white rounded-md bg-blue-700 hover:bg-blue-900 transition"
        >
          Apply now
        </a>
      </div>
    </div>

    <!-- Card 3: Stand-Up India -->
    <div
      class="w-full p-6 flex flex-col items-center text-center rounded-lg shadow-md border border-gray-300 bg-gray-50"
      data-aos="zoom-in"
      data-aos-duration="500"
    >
      <div class="w-36 aspect-[4/3] mb-4">
        <img
          src="https://cdn.jsdelivr.net/gh/heisenpreet/ibankeyAssest@master/standUpIndia.png"
          class="w-full h-full object-contain rounded-md"
          alt="SUI - Stand-Up India Scheme"
        />
      </div>
      <p class="text-3xl font-semibold text-gray-900">SUI</p>
      <p class="text-sm text-gray-600">Stand-Up India Scheme.</p>
      <p class="text-3xl text-gray-900 font-bold mt-5">
        <i class="fa-solid fa-indian-rupee-sign"></i> 1 Cr.
      </p>
      <p class="text-sm text-gray-600 mt-2 px-6">
        Provides loans to women and SC/ST entrepreneurs for setting up
        greenfield enterprises
      </p>
      <div class="flex gap-6 mt-3">
        <a
          href="#"
          aria-label="Learn more about Stand-Up India scheme"
          class="group inline-flex items-center text-gray-800 hover:text-blue-600 border border-transparent hover:border-blue-600 px-4 py-2 rounded-full transition-all duration-300"
        >
          Learn More
          <i
            class="fa-solid fa-arrow-right text-lg ml-2 transform group-hover:translate-x-1 transition-transform duration-300"
          ></i>
        </a>
        <a
        href="${currentUrl}/signup/#/signupBorrower"
        aria-label="Apply for Stand-Up India scheme"
          class="px-6 py-2 text-white rounded-md bg-blue-700 hover:bg-blue-900 transition"
        >
          Apply now
        </a>
      </div>
    </div>

    <!-- Card 4: MUDRA -->
    <div
      class="w-full p-6 flex flex-col items-center text-center rounded-lg shadow-md border border-gray-300 bg-gray-50"
      data-aos="zoom-in"
      data-aos-duration="500"
    >
      <div class="w-36 aspect-[4/3] mb-4">
        <img
          src="https://cdn.jsdelivr.net/gh/heisenpreet/ibankeyAssest@master/mudra.png"
          class="w-full h-full object-contain"
          alt="MUDRA - Pradhan Mantri Mudra Yojana"
        />
      </div>
      <p class="text-3xl font-semibold text-gray-900 py-2">MUDRA</p>
      <p class="text-xs text-gray-600">Pradhan Mantri Mudra Yojana.</p>
      <p class="text-3xl text-gray-900 font-bold mt-5">
        <i class="fa-solid fa-indian-rupee-sign"></i> 20 Lakh.
      </p>
      <p class="text-xs text-gray-600 mt-2 px-6">
        Provides micro-financing to non-corporate, non-farm small/micro
        enterprises and 50% guarantee coverage
      </p>
      <div class="flex gap-6 mt-auto">
        <a
          href="#"
          aria-label="Learn more about MUDRA scheme"
          class="group inline-flex items-center text-gray-800 hover:text-blue-600 border border-transparent hover:border-blue-600 px-4 py-2 rounded-full transition-all duration-300"
        >
          Learn More
          <i
            class="fa-solid fa-arrow-right text-lg ml-2 transform group-hover:translate-x-1 transition-transform duration-300"
          ></i>
        </a>
        <a
        href="${currentUrl}/signup/#/signupBorrower"
        aria-label="Apply for MUDRA scheme"
          class="px-6 py-2 text-white rounded-md bg-blue-700 hover:bg-blue-900 transition"
        >
          Apply now
        </a>
      </div>
    </div>
  </div>
</div>

<p
  class="text-3xl font-bold text-blue-800 text-center pt-20"
  data-aos="fade-up"
  data-aos-duration="500"
>
  Facts That Speak for Us
</p>
<p
  class="py-2 text-center text-gray-600 mb-6 py-3"
  data-aos="fade-up"
  data-aos-duration="500"
>
  We are a full-stack institutional debt raising platform that <br />
  offers solutions to all stakeholders
</p>

<div class="w-full flex justify-center mb-5 lg:mb-10 px-2 lg:px-0">
  <div
    class="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-3 lg:grid-cols-4 gap-1 lg:gap-8"
  >
    <!-- col1 -->
    <div
      class="bg-blue-900 text-white rounded-xl p-6 w-44 lg:w-48 text-center shadow-xl"
      data-aos="fade-up"
      data-aos-duration="500"
    >
 <img src="https://cdn.jsdelivr.net/gh/heisenpreet/ibankeyAssest@master/uptrend.png"
            class="mx-auto w-16 h-auto mb-4"
            alt="Deals Facilitated"
          />

      <p class="text-3xl font-bold text-gray-100">200+</p>
      <p class="text-sm font-semibold mt-1">Deals Facilitated</p>
    </div>
    <!-- col2 -->
    <div
      class="bg-blue-600 text-white rounded-xl p-6 w-44 lg:w-48 text-center shadow-xl"
      data-aos="fade-up"
      data-aos-duration="500"
    >
       <img
            src="https://cdn.jsdelivr.net/gh/heisenpreet/ibankeyAssest@master/analysis.svg"
            class="mx-auto w-16 h-auto mb-4"
            alt="Businesses Active"
          />
      <p class="text-3xl font-bold text-gray-100">100+</p>
      <p class="text-sm font-semibold mt-1">Businesses Active on Platfrom</p>
    </div>
    <!-- col3 -->
    <div
      class="bg-blue-900 text-white rounded-xl p-6 w-44 lg:w-48 text-center shadow-xl"
      data-aos="fade-up"
      data-aos-duration="500"
    >
      <img
            src="https://cdn.jsdelivr.net/gh/heisenpreet/ibankeyAssest@master/contract.png"
            class="mx-auto w-16 h-auto mb-4"
            alt="Lenders Onboarded"
          />
      <p class="text-3xl font-bold text-gray-100">60+</p>
      <p class="text-sm font-semibold mt-1">Lenders Onboarded</p>
    </div>

    <!-- col4 -->
    <div
      class="bg-blue-600 text-white rounded-xl p-6 w-44 lg:w-48 text-center shadow-xl"
      data-aos="fade-up"
      data-aos-duration="500"
    >
      <img
            src="https://cdn.jsdelivr.net/gh/heisenpreet/ibankeyAssest@master/barchart.png"
            class="mx-auto w-16 h-auto mb-4"
            alt="Volume Facilitated"
          />
      <p class="text-3xl font-bold text-gray-100 text-nowrap">2000cr+</p>
      <p class="text-sm font-semibold mt-1">Volume Facilitated</p>
    </div>
  </div>
</div>
`;
